export default __webpack_public_path__ + "static/media/logo_placeholder.d85c4644.jpg";